import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Offcanvas from "../components/Offcanvas";
import SearchArea from "../components/SearchArea";
import BreadcrumbSection from "../components/BreadcrumbSection";
import ContactInfoSection from "../components/ContactInfoSection";
import ContactSection from "../components/ContactSection";
import MapSection from "../components/MapSection";

function ContactUs() {
  return (
    <>
      <Offcanvas />
      <SearchArea />
      <Header />
      <BreadcrumbSection />
      <ContactInfoSection />
      <ContactSection />
      <MapSection />
      <Footer />
    </>
  );
}

export default ContactUs;